import { useState } from "react";
import { Copy, Check } from "lucide-react";
import { toast } from "sonner";
import { SITE } from "@/data/site";

export const CopyContract = ({ variant = "full", testId = "copy-contract" }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(SITE.contractAddress);
    } catch (e) {
      const ta = document.createElement("textarea");
      ta.value = SITE.contractAddress;
      document.body.appendChild(ta);
      ta.select();
      document.execCommand("copy");
      document.body.removeChild(ta);
    }
    setCopied(true);
    toast.success("Contract address copied! 🔥", {
      description: "Welcome to the stampede, degen.",
    });
    setTimeout(() => setCopied(false), 2000);
  };

  const truncated = `${SITE.contractAddress.slice(0, 6)}...${SITE.contractAddress.slice(-6)}`;

  return (
    <button
      onClick={handleCopy}
      data-testid={testId}
      className="group flex items-center gap-3 glass rounded-md px-4 py-3 hover:border-gold/60 transition-colors duration-300 w-full max-w-md"
    >
      <span className="text-[10px] font-body font-semibold tracking-widest uppercase text-gold shrink-0">
        CA
      </span>
      <span className="font-mono text-sm text-gray-200 truncate flex-1 text-left">
        {variant === "full" ? SITE.contractAddress : truncated}
      </span>
      {copied ? (
        <Check className="w-4 h-4 text-green-400 shrink-0" />
      ) : (
        <Copy className="w-4 h-4 text-gray-400 group-hover:text-gold transition-colors duration-300 shrink-0" />
      )}
    </button>
  );
};
